import React, { FC, useEffect } from 'react';
import { ReportingDetailsIndicatorsTemplate } from '../../templates';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import {
  deleteIndicator,
  fetchIndicators,
} from '../../../store/landscapeAPI/indicator/reducers/indicator.slice';
import Spinner from '../../atoms/Spinner/Spinner';
import cn from 'classnames';
import styles from './ReportingDetailsIndicatorsPage.module.css';

interface ReportingDetailsIndicatorsPageProps {}

const ReportingDetailsIndicatorsPage: FC<
  ReportingDetailsIndicatorsPageProps
> = () => {
  const { indicators, status } = useSelector(
    (state: RootState) => state.indicatorSlice
  );

  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(fetchIndicators());
  }, [dispatch]);

  const handleDeleteIndicator = (id: string) => {
    dispatch(deleteIndicator({ existingId: id, compactId: null }));
  };

  if (status === 'loading') {
    return <Spinner />;
  }

  return (
    <div className={cn(styles.wrapper)}>
      <ReportingDetailsIndicatorsTemplate
        data={indicators ?? []}
        handleDeleteIndicator={handleDeleteIndicator}
      />
    </div>
  );
};

export default ReportingDetailsIndicatorsPage;
